var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('Filtro',{on:{"search":_vm.getLaunch}}),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.data.length <= 0)?_c('base-loading'):_vm._e()],1),_c('v-col',{attrs:{"cols":"12"}},[(_vm.data.length >= 1)?_c('Tables',{attrs:{"data":_vm.data,"consultor":_vm.$user.get().name}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }